// EmailVerification.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const EmailVerification = () => {
  const { token } = useParams(); // Get the token from the URL params

  const [verificationStatus, setVerificationStatus] = useState('Verifying...');
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    // Make an API request to your server to verify the email
    axios.get(`https://campus-closet-server.vercel.app/verify?token=${token}`)
      .then((response) => {
        setIsVerified(true);
        setVerificationStatus('Email verified successfully! Proceed to login');
      })
      .catch((error) => {
        setIsVerified(false);
        setVerificationStatus('Email verification failed. Please try again.');
      });
  }, [token]);

  return (
    <div className='min-h-screen flex items-center justify-center bg-gray-50'>
      <div className='p-8 bg-white border border-gray-300 rounded-lg shadow-md'>
        {isVerified ? (
          <div className='flex items-center justify-center'>
            <FaCheckCircle className='text-green-500 text-4xl' />
            <h2 className='text-xl ml-2 font-bold text-gray-800'>{verificationStatus}</h2>
          </div>
        ) : (
          <div className='flex items-center justify-center'>
            <FaTimesCircle className='text-red-500 text-4xl' />
            <h2 className='text-xl ml-2 font-bold text-gray-800'>{verificationStatus}</h2>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;
